import { Card, 
  CardContent, 
  CardHeader, 
  Divider, 
  Link, 
  ListItem, 
  ListItemText, 
  Pagination, 
  Typography } from "@mui/material";
import { ChangeEvent, FC, useState } from "react";
import { AlertAndTime } from "@/gen/api/backup";
import { useEffect } from "react";
import { useCallback } from "react";
import { chunk } from 'lodash'
import { AlertIcon, AlertList, displayAlert, NoAlerts } from "../dashboard/alertCard";
import { useUserTimeFormat } from "@/utils/userTimeFormat";
import { Link as RouteLink } from 'react-router-dom'
import { genUrlWithHashid } from "@/utils/hashid";


const pageSize = 3;

export interface AlertsCardProps {
  alertInfo: AlertAndTime[] | undefined | null;
  title: string;
}

const AlertsCard: FC<AlertsCardProps> = ({
  alertInfo,
  title,
}) => {
  const [page, setPage] = useState(1) // 1 based page location
  const [alertChunks, setAlertChunks] = useState<AlertAndTime[][]>([])
  useEffect(() => {
    setPage(1)
    setAlertChunks(chunk(alertInfo, pageSize))
  }, [alertInfo, setPage, setAlertChunks])

  const handleChange = useCallback((e: ChangeEvent<any>, value: number) => {
    setPage(value)
  }, [setPage])

  const format = useUserTimeFormat()
  return (
    <Card>
      <CardHeader
        title={(
          <Typography
            color="textPrimary"
            variant="h6"
          >
            {title}
          </Typography>
        )}
      />
      <CardContent sx={{ pt: 0 }} >
        <Divider />
        {alertInfo && alertInfo.length > 0 ?
        
          <AlertList>
            {alertChunks[page - 1]?.map((a, i) => (
              <ListItem key={a.databaseId + '' + i} disableGutters divider >
                <Link 
                  underline="none"
                  component={RouteLink}
                  to={genUrlWithHashid('/backups-n-validations/list/$0/show', a.databaseId || 0)}
                >
                  <AlertIcon {...a} />
                  <ListItemText
                    disableTypography
                    primary={(
                      <Typography
                        className={a.isWarning ? 'warning' : 'error'}
                        variant="body2"
                      >
                        {displayAlert(a)}
                      </Typography>
                    )}
                    secondary={(
                      <Typography
                        className={a.isWarning ? 'warning' : 'error'}
                        variant="caption"
                      >
                        {a.alertTime && format(a.alertTime, 'PPp')}
                      </Typography>
                    )}
                  />
                </Link>
              </ListItem>
            ))}
          </AlertList> :
          <NoAlerts />
        }
        {(alertInfo?.length || 0) <= pageSize ? null :
          <Pagination 
            count={Math.ceil((alertInfo?.length || 0) / pageSize)} 
            page={page}
            defaultPage={1}
            sx={{ mb: -2 }} 
            onChange={handleChange} 
          />        
        }
      </CardContent>
    </Card>
  )
}

export default AlertsCard;

